<template>
  <div class="list">
    <div class="container_wrap">
      <Header />

      <div class="list_container">
        <el-row :gutter="15">
          <el-col :span="7">
            <div class="sec_wrap">
              <div class="sec_tit">
                <span>集团动态</span>
              </div>
              <ul class="list_l_jtdt">
                <li
                  class="single-line"
                  v-for="(item, index) in newsJtdt"
                  :key="index"
                >
                  <a :href="`/zy/detail?id=${item.id}&navName=${name1}&groupName=${name2}`">{{ item.title }}</a>
                </li>
              </ul>
            </div>

            <div class="sec_wrap" style="margin-top: 12px;">
              <div class="sec_tit">
                <span>图片新闻</span>
              </div>
              <div class="list_l_xwdt">
                
                <!-- <el-row class="list_l_xwdt_list" :gutter="6" v-for="(item, index) in newsJtdt"
                  :key="index">
                  <el-col :span="9">
                    <a class="list_l_xwdt_list_img" :href="`/zy/detail?id=${item.id}&navName=${name1}&groupName=${name2}`"
                      ><img :src="item.img" alt=""
                    /></a>
                  </el-col>
                  <el-col :span="15">
                    <p>
                      <a :href="`/zy/detail?id=${item.id}&navName=${name1}&groupName=${name2}`"> {{ item.title }} </a>
                    </p>
                  </el-col>
                </el-row> -->

                <div class="list_l_xwdt_list clearfloat" v-for="(item, index) in newsJtdt"
                  :key="index">
                  <div class="fl list_l_xwdt_fl">
                    <a class="list_l_xwdt_list_img" :href="`/zy/detail?id=${item.id}&navName=${name1}&groupName=${name2}`"
                      ><img :src="item.img" alt=""
                    /></a>
                  </div>
                  <div class="list_l_xwdt_inner">
                    <p>
                      <a :href="`/zy/detail?id=${item.id}&navName=${name1}&groupName=${name2}`"> {{ item.title }} </a>
                    </p>
                  </div>
                </div>


              </div>
            </div>
          </el-col>
          <el-col :span="17">
            <div class="list_hd">
              <span class="list_hd_posi"></span>
              <span class="list_hd_page"><a href="/">首页</a> > </span>
              <span class="list_hd_page" v-show="navNameShow"><a :href="navNameUrl">{{name1}}</a>  > </span>
              <span class="list_hd_page"><a href="">{{name2}}</a>  > </span>
              <span class="list_hd_page">正文</span>
            </div>
            
            <div class="detail_wrap">
              <div class="detail_hd">
                <div class="detail_hd_title">{{cont.title}}</div>
                <div class="detail_hd_inner">
                  <span>浏览次数：<label>{{cont.view_number}}</label></span>
                  <span>发布时间：<label>{{ dayjs(cont.update_time).format('YYYY-MM-DD') }}</label></span>
                </div>
              </div>
              <div class="detail_cont" v-html="cont.content"></div>
            </div>
            
            <div class="pagepic">
              <img src="http://www.ghatg.com/gsghl/template/images/B_print.gif" @click="doPrint()"> 
              <img src="http://www.ghatg.com/gsghl/template/images/B_close.gif" @click="windowClose()"> 
              <img src="http://www.ghatg.com/gsghl/template/images/B_top.gif" @click="toTop()">
            </div>

          </el-col>
        </el-row>
        
      </div>

      <Footer />
    </div>
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";

export default {
  name: "detail",
  components: {
    Header,
    Footer
  },
  data(){
    return {
      name1: '',
      name2: '',
      cont: {},
      newsJtdt: [],
      navNameUrl: '',
      navNameList: {
        '公司概况': '/company',
        '新闻中心': '/news',
        '集团业务': '/business',
        '招贤纳士': '/zy/list?id=20&navName=招贤纳士&groupName=人才招聘',
        '专题专栏': '/special',
        '党建之窗': '/party',
      },
      navNameShow: true
    }
  },
  mounted() {
    var _this = this;
    if(_this.$route.query.navName){
      _this.navNameShow = true
      _this.name1 = _this.$route.query.navName;
      _this.navNameUrl = _this.navNameList[_this.$route.query.navName]
    }else{
      _this.navNameShow = false
    }
    _this.name2 = _this.$route.query.groupName;
    // console.log( _this.$route.query.noList)
    if(_this.$route.query.noList == 1){
      _this.getData2();
    }else{
      _this.getData();
    }
    _this.getJtdtNews();
  },
  methods: {
    pageList(index){
      console.log('index :>> ', index);
    },
    doPrint() {
      var bdhtml=window.document.body.innerHTML;
      
      var sprnstr="<!--startprint-->";   
      var eprnstr="<!--endprint-->";   
      var prnhtml=bdhtml.substr(bdhtml.indexOf(sprnstr)+17);   
      prnhtml=prnhtml.substring(0,prnhtml.indexOf(eprnstr));   
      window.document.body.innerHTML=prnhtml;  
      window.print();   
    },
    windowClose(){
      window.opener = null;
      window.open("about:blank", "_top").close()
    },
    toTop(){
      document.removeEventListener('scroll', this.handleScroll)
      document.body.scrollTop = document.documentElement.scrollTop = 0
    },
    async getData() {
      var _this = this;
      var id = _this.$route.query.id;
      var { data } = await _this.$http.post( _this.apiUrl + "/news/getNewsDetail", { id: id });
      _this.cont = data.data;
    },
    async getData2() {
      var _this = this;
      var {data} = await _this.$http.post( _this.apiUrl + "/news/getNewsList", {
        page: 1,
        group_id: _this.$route.query.id,
      });
      var detail = await _this.$http.post( _this.apiUrl + "/news/getBackstageNewsDetail", { id: data.data.list[0].id });
      _this.cont = detail.data.data;
    },
    async getJtdtNews() {
      var _this = this;
      var { data } = await _this.$http.post(
        _this.apiUrl + "/news/getNewsList",
        { page: 1, group_id: 70 }
      );
      _this.newsJtdt = data.data.list.slice(0, 5);
    },

  }
}
</script>

<style scoped>

</style>